import { InitialStateType } from '../AppContext';
import { ActionType } from '../models/appContext';
import { companyReducer } from './companyReducer';
import { confirmationReducer } from './confirmationReducer';
import { contactReducer } from './contactReducer';
import { invoiceReducer } from './invoiceReducer';
import { membershipReducer } from './membershipReducer';
import { messageReducer } from './messageReducer';
import { productReducer } from './ProductReducer';
import { recipientListReducer } from './recipientReducer';
import { selectedUserReducer, userReducer } from './userReducer';

export const mainReducer = (
  {
    user,
    message,
    confirmation,
    routes,
    selectedContact,
    selectedMembership,
    selectedInvoice,
    selectedUser,
    selectedCompany,
    selectedProduct,
    selectedRecipientList
  }: InitialStateType,
  action: ActionType
) => ({
  message: messageReducer(message, action),
  confirmation: confirmationReducer(confirmation, action),
  user: userReducer(user, action),
  selectedMembership: membershipReducer(selectedMembership, action),
  selectedContact: contactReducer(selectedContact, action),
  selectedInvoice: invoiceReducer(selectedInvoice, action),
  selectedUser: selectedUserReducer(selectedUser, action),
  selectedCompany: companyReducer(selectedCompany, action),
  selectedProduct: productReducer(selectedProduct, action),
  selectedRecipientList: recipientListReducer(selectedRecipientList, action),
  routes
});
